import {Platform} from 'react-native';
import {dateFormats} from '../../../../shared/constants/date';
import {Act, Agreement} from '../../../../shared/models/api';
import {ProfileApplicationsStatus} from '../../../../shared/models/profile/applications';
import {datePipe} from '../../../../shared/pipes';

export interface DocumentsProps {
  documents: Document[] | null;
  onLoadMore(): void;
  allShown: boolean;
  onPressItem(document: Document): void;
  onPressShowFilter(): void;
  onApplyFilter(formData: any): void;
}

export type Document = (Agreement & {type: 'agreement'}) | (Act & {type: 'act'});

export const sortInPlaceDocumentsByUpdateDate = (documents: Document[]) =>
  documents.sort((a: Document, b: Document) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());

export const buildDocumentName = (document: Document) => {
  if (document.type === 'act') {
    const actName = `Акт №${document.number} от ${datePipe(document.date, dateFormats.fullDate)} по Договору №${
      document.agreementNumber
    } (${document.providerName}) от ${datePipe(document.agreementConclusionDate, dateFormats.fullDate)}`;
    return Platform.OS === 'web' ? actName : actName.replace(/[\/\\:*?"<>|()\[\]]/g, '_').trim();
  }
  if (document.type === 'agreement') {
    const agreementName = `Договор №${document.number} от ${datePipe(document.conclusionDate, dateFormats.fullDate)}`;
    return Platform.OS === 'web' ? agreementName : agreementName.replace(/[\/\\:*?"<>|()\[\]]/g, '_').trim();
  }
  return '';
};

export const statusType = (document: Document): ProfileApplicationsStatus => {
  if (document.isSigned) return 3;
  return 4;
};

export const statusName = (document: Document) => {
  if (document.isSigned) return 'Подписано';
  return 'Не подписано';
};
